import { NotificationsHeader } from "./components/NotificationsHeader";
import { useIsEstablishmentManager } from "../../common/utils/useIsEstablishmentManager";
import { EstablishmentNotifications } from "./components/establishmentManager/EstablishmentNotifications";
import { EmployeeNotifications } from "./components/employee/EmployeeNotifications";
import { JSX } from "react";

const NotificationsPageContainer = (): JSX.Element => {
    const isEstablishmentManager = useIsEstablishmentManager();

    return (
        <section className="p-notifications">
            <NotificationsHeader />
            {isEstablishmentManager ? (
                <EstablishmentNotifications />
            ) : (
                <EmployeeNotifications />
            )}
        </section>
    );
};

export default NotificationsPageContainer;
